import React from "react";
import { Link } from "react-router-dom";

export function Logo({ to = "/", className = "", showText = true }) {
  return (
    <Link to={to} data-testid="logo-link" className={`inline-flex items-center gap-2.5 group ${className}`}>
      <span className="relative grid place-items-center w-8 h-8 rounded-[9px] bg-primary shadow-[0_2px_8px_hsl(232_80%_55%/0.35)]">
        <span className="absolute w-3 h-3 rounded-[3px] bg-white/90" />
        <span className="absolute w-3 h-3 rounded-[3px] bg-white/30 translate-x-[3px] translate-y-[3px]" />
      </span>
      {showText && (
        <span className="inline-flex items-center gap-1.5">
          <span className="font-semibold text-[19px] tracking-[-0.03em] text-foreground">
            Compeni
          </span>
          <span data-testid="beta-badge" className="text-[10px] font-semibold uppercase tracking-wide text-primary bg-primary/10 rounded-full px-1.5 py-0.5 leading-none">
            Beta
          </span>
        </span>
      )}
    </Link>
  );
}
